export default Object.freeze({
  ACTIVATE: 'Activate',
  ALL_TAG_VALUE: '_toSeeAllData',
  COMPONENT_NAME_ADMIN_PAGE: 'adminPage',
  COMPONENT_NAME_ALERT: 'mediaAlert',
  COMPONENT_NAME_LED_PAGE: 'mediaLED',
  COMPONENT_NAME_VIDEOWALL_PAGE: 'mediaVideowall',
  COMPONENT_NAME_MEDIA_FILES: 'mediaFiles',
  COMPONENT_NAME_MEDIA_PICKER: 'mediaListInModal',
  COMPONENT_NAME_MONITORING: 'monitoringPage',
  COMPONENT_NAME_PLAYERS_PAGE: 'playerPage',
  COMPONENT_NAME_MONITORING_PAGE: 'monitoringPage',
  COMPONENT_NAME_SCHEDULE_PAGE_ALL_PLAYERS: 'schedulePagePlayers',
  COMPONENT_NAME_REPORTING_PAGE: 'reportingPage',
  EMIT_EVENT_SEARCH_TEXT_CHANGED_ENTER: 'SEARCH_TEXT_CHANGED_ENTER',
  EMIT_EVENT_SEARCH_TEXT_CHANGED_TYPING: 'SEARCH_TEXT_CHANGED_TYPING',
  EMIT_EVENT_SELECTED_MEDIA_TYPES_CHANGED: 'SELECTED_MEDIA_TYPES_CHANGED',
  EMIT_EVENT_NEW_SELECTED_TAGS_FROM_SLIDER: 'NEW_SELECTED_TAGS_FROM_SLIDER',
  EMIT_EVENT_REFETCH_PARENT_COMPONENT_LIST: 'REFETCH_PARENT_COMPONENT_LIST',
  EMIT_EVENT_DONE_FETCHING_TAGS_FROM_SLIDER: 'DONE_FETCHING_TAGS_FROM_SLIDER',
  EMIT_EVENT_ALL_TAG_SELECTED_FROM_SLIDER: 'ALL_SELECTED_FROM_SLIDER',
  EMIT_EVENT_UPDATING_TAG_FROM_SLIDER: 'UPDATING_TAG_FROM_SLIDER',
  EMIT_EVENT_DELETED_TAG_FROM_SLIDER: 'DELETED_TAG_FROM_SLIDER',
  EMIT_EVENT_NEW_SELECTED_POP_ID_FROM_SLIDER: 'NEW_SELECTED_POP_ID_FROM_SLIDER',
  EMIT_EVENT_ALL_SELECTED_POPID_FROM_SLIDER: 'ALL_SELECTED_POPID_FROM_SLIDER',
  EMIT_EVENT_DELETED_POPID_FROM_SLIDER: 'DELETED_POPID_FROM_SLIDER',
  EMIT_EVENT_LIST_OF_POP_IDS_FROM_SLIDER: 'LIST_OF_POP_IDS_FROM_SLIDER',
  EMIT_EVENT_NEW_SELECTED_LED_TAG: 'NEW_SELECTED_LED_TAG',
  EMIT_EVENT_DELETED_LED_TAG: 'DELETED_LED_TAG',
  FILTER_KEY_LED_TAGS: 'ledTags',
  FILTER_KEY_VIDEOWALL_TAGS: 'videowallTags',
  FILTER_KEY_MEDIA_TAGS: 'mediaTags',
  FILTER_KEY_MEDIA_TYPES: 'mediaTypes',
  FILTER_KEY_POPIDS: 'popIds',
  FILTER_KEY_PLAYER_TAGS: 'playerTags',
  FILTER_KEY_SEARCH_TEXT: 'searchText',
  FILTER_KEY_ORIENTATION: 'orientation',
  FILTER_KEY_SCHEDULED: 'scheduled',
  FILTER_KEY_MODIFIED_AT_FROM: 'modifiedAtFrom',
  FILTER_KEY_MODIFIED_AT_TO: 'modifiedAtTo',
  FILTER_KEY_SORT_ORDER: 'sortOrder',
  /** API default sort — omit the param when this is in effect to keep URLs clean. */
  SORT_ORDER_DEFAULT: 'desc',
  MEDIA_SORT_DESC: 'desc',
  MEDIA_SORT_ASC: 'asc',
  MEDIA_SORT_NAME_DESC: 'desc:name',
  MEDIA_SORT_NAME_ASC: 'asc:name',
  MEDIA_COMPONENT_AS_MEDIA_FILES: 'mediaFiles',
  MEDIA_COMPONENT_AS_ALERT_FILES: 'mediaAlert',
  MEDIA_COMPONENT_AS_LED_FILES: 'mediaLED',
  MEDIA_COMPONENT_AS_VIDEOWALL_FILES: 'mediaVideowall',
  MEDIA_TYPE_VALUE_IMAGE: 'img',
  MEDIA_TYPE_VALUE_VIDEO: 'video',
  MEDIA_TYPE_VALUE_PROJECT: 'project',
  MEDIA_TYPE_VALUE_SCHEDULED: 'scheduled',
  MEDIA_TYPE_VALUE_AUDIO: 'audio',
  MEDIA_TYPE_VALUE_ELEMENTI: 'elementi',
  MEDIA_TYPE_VALUE_AUDIO_PLAYLIST: 'audio-playlist',
  MEDIA_TYPE_VALUE_LOGO: 'logo',
  MEDIA_TYPE_VALUE_PDF: 'pdf',
  MEDIA_TYPE_VALUE_SNAPSHOT: 'snapshot',
  MEDIA_TYPE_NAME_IMAGE: 'image',
  MEDIA_TYPE_NAME_VIDEO: 'video',
  MEDIA_TYPE_NAME_PROJECT: 'project',
  MEDIA_TYPE_NAME_SCHEDULED: 'schedule',
  MEDIA_TYPE_NAME_AUDIO: 'audio',
  MEDIA_TYPE_NAME_ELEMENTI: 'elementi',
  MEDIA_TYPE_NAME_AUDIO_PLAYLIST: 'audio-playlist',
  MEDIA_PREVIEW_TYPE_VALUE_HTML: 'html',
  MEDIA_PREVIEW_TYPE_VALUE_SVG: 'svg',
  ORIENTATION_VALUE_HORIZONTAL: 'horizontal',
  ORIENTATION_VALUE_VERTICAL: 'vertical',
  PROJECT_CREATE_AUDIO_PLAYLIST: 'CREATE_PROJECT_AUDIO_PLAYLIST',
  PROJECT_EDIT_AUDIO_PLAYLIST: 'EDIT_PROJECT_AUDIO_PLAYLIST',
  ROUTE_NAME_LED: 'led-configuration',
  ROUTE_NAME_VIDEOWALL: 'videowall',
  ROUTE_NAME_MEDIA: 'media',
  ROUTE_NAME_ALERT: 'alert',
  PASSWORD_REGEX: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{8,}$/,
  USER_NOT_CONFIRMED: 'UserNotConfirmedException',
  USER_NOT_FOUND: 'UserNotFoundException',
  NOT_AUTHORIZED: 'NotAuthorizedException',
  USER_NOT_AUTHORIZED: 'NotAuthorizedUserException',
  INVALID_PASSWORD: 'InvalidPasswordException',
  INVALID_PARAMETER_EXCEPTION: 'InvalidParameterException',
  USER_LAMBDA_VALIDATION_EXCEPTION: 'UserLambdaValidationException',
  USERNAME_EXISTS_EXCEPTION: 'UsernameExistsException',
  EXPIRED_CODE_EXCEPTION: 'ExpiredCodeException',
  CODE_MISMATCH_EXCEPTION: 'CodeMismatchException',
  PRODUCT_ARYA: 'arya',
  PRODUCT_ACTIVATE: 'activate',
  GOOGLE: 'Google',
  FACEBOOK: 'Facebook',
  UNAUTHORIZED_CODE: 401,
  FORBIDDEN_CODE: 403,
  FILE_UPLOAD_ITEM_STATUS: {
    READY: 'ready',
    UPLOAD: 'upload',
    QUEUED: 'queued',
    PROCESS: 'process',
    PROGRESS: 'progress',
    FAILED: 'failed',
    CANCEL: 'cancel',
    FINISH: 'finish',
    FINISHED: 'finished'
  }
})
